import React from 'react';

export default function useElementHeight(el: React.RefObject<HTMLElement>) {
  const [height, setHeight] = React.useState(el.current?.getBoundingClientRect().height ?? null);
  const updateHeight = React.useCallback(() => {
    if (!el.current) {
      return;
    }
    setHeight(el.current.getBoundingClientRect().height);
  }, [el]);

  React.useEffect(() => {
    if (!el.current) {
      return;
    }

    const ro = new ResizeObserver(updateHeight);
    ro.observe(el.current);

    updateHeight(); // set initial height
    window.addEventListener('resize', updateHeight);

    return () => {
      ro.disconnect();
      window.removeEventListener('resize', updateHeight);
    };
  }, [el, updateHeight]);

  return {
    height: height,
  };
}
